module.exports = __webpack_public_path__ + "static/media/logo_login.679266f4.svg";